import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';

const getPayload = (res) => {
  if (
    res &&
    typeof res === 'object' &&
    ('success' in res ||
      'status' in res ||
      'isSuccess' in res ||
      'message' in res)
  ) {
    return res;
  }

  if (
    res?.data &&
    typeof res.data === 'object' &&
    ('success' in res.data ||
      'status' in res.data ||
      'isSuccess' in res.data ||
      'message' in res.data)
  ) {
    return res.data;
  }

  return res ?? {};
};

const AddEditLeadAutoAssignUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);

  const { isSuperAdmin, isAdmin, hasMultiBranch } = useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [userList, setUserList] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    user_id: '',
    user_name: '',
    is_active: true,
  });

  useEffect(() => {
    if (location.state) {
      setFormData((prev) => ({
        ...prev,
        ...location.state,
        id: Number(location.state?.id || 0),
        vendor_id: Number(location.state?.vendor_id || 0),
        branch_id: Number(location.state?.branch_id || 0),
        user_id:
          location.state?.user_id === null ||
          location.state?.user_id === undefined
            ? ''
            : String(location.state.user_id),
        user_name: location.state?.user_name || '',
        is_active: location.state?.is_active ?? true,
      }));
    }
  }, [location.state]);

  const loadUsers = async () => {
    try {
      const res = await apiService.get(
        `api/admin/User_Detail/GetUsers?filter=operator`,
      );

      const payload = getPayload(res);

      const rows =
        payload?.user_DetailData ||
        payload?.user_Detail_List ||
        payload?.data ||
        payload?.users ||
        [];

      setUserList(Array.isArray(rows) ? rows : []);
    } catch (e) {
      console.error(e);
      setUserList([]);
    }
  };

  const loadById = async (id) => {
    try {
      const res = await apiService.get(`api/LeadAutoAssignUser/Get?id=${id}`);
      const payload = getPayload(res);

      if (
        payload?.success === true ||
        payload?.status === true ||
        payload?.isSuccess === true
      ) {
        const row = Array.isArray(payload?.data)
          ? payload.data[0]
          : payload?.data || {};

        setFormData((prev) => ({
          ...prev,
          ...row,
          id: Number(row?.id || 0),
          vendor_id: Number(row?.vendor_id || 0),
          branch_id: Number(row?.branch_id || 0),
          user_id:
            row?.user_id === null || row?.user_id === undefined
              ? ''
              : String(row.user_id),
          user_name: row?.user_name || '',
          is_active: row?.is_active ?? true,
        }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    if (location.state?.id) {
      loadById(location.state.id);
    }
  }, [location.state?.id]);

  const onChangeHandle = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'user_id') {
      const picked = userList.find((x) => String(x.id) === String(value));
      const pickedName = (
        picked?.user_name ||
        picked?.name ||
        picked?.username ||
        ''
      ).trim();

      setFormData((prev) => ({
        ...prev,
        user_id: value,
        user_name: pickedName,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const Save = async () => {
    if (
      isSuperAdmin &&
      (!formData.vendor_id || Number(formData.vendor_id) <= 0)
    ) {
      toast.error('Please select Vendor');
      return;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!formData.branch_id || Number(formData.branch_id) <= 0)
    ) {
      toast.error('Please select Branch');
      return;
    }

    if (!formData.user_id || String(formData.user_id) === '') {
      toast.error('Please select User');
      return;
    }

    try {
      const payload = {
        ...formData,
        id: Number(formData.id || 0),
        vendor_id: Number(formData.vendor_id || 0),
        branch_id: Number(formData.branch_id || 0),
        user_id: Number(formData.user_id || 0),
        user_name: formData.user_name || '',
        is_active: !!formData.is_active,
      };

      const res = await apiService.post(`api/LeadAutoAssignUser/Save`, payload);
      const response = getPayload(res);

      if (
        response?.success === true ||
        response?.status === true ||
        response?.isSuccess === true
      ) {
        toast.success(response?.message || 'Saved successfully');
        navigate('/list-auto-assign');
      } else {
        toast.error(response?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={formData}
        setSelectionData={setFormData}
        accessButton={true}
        errorMessage={errorMessage}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Lead Auto Assign User</span>
          <Button color='warning' onClick={() => navigate(-1)}>
            <i className='bi bi-arrow-left' />
          </Button>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>User</Label>
              <Input
                type='select'
                name='user_id'
                className='custom-select'
                value={formData.user_id}
                onChange={onChangeHandle}
              >
                <option value=''>Select</option>
                {userList.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.user_name || u.name || u.username || ''}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-6 mt-4'>
              <Label check>
                <Input
                  type='checkbox'
                  name='is_active'
                  checked={!!formData.is_active}
                  onChange={onChangeHandle}
                />{' '}
                Active
              </Label>
            </FormGroup>
          </Row>

          <Button color='primary' className='float-end mt-3' onClick={Save}>
            Save
          </Button>
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditLeadAutoAssignUser;
